import * as React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";

export default function Main({ title, children }) {
  return (
    <div className="bg-white min-h-screen flex flex-col font-sans text-brand-dark">
      <title>{title}</title>
      <NavBar />

      <main className="grow w-full max-w-7xl mx-auto pt-32 px-6 py-12 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-24 items-start">
        {children}
      </main>

      <Footer />
    </div>
  );
}

export function MainDark({ title, children }) {
  return (
    <div className="bg-white min-h-screen flex flex-col font-sans text-brand-dark">
      <title>{title}</title>
      <div class="bg-white">
        <NavBar />
      </div>

      <main className="bg-white">{children}</main>

      <Footer />
    </div>
  );
}

export function LightContentBlock({ children }) {
  return (
    <div className="md:col-span-8 lg:col-span-9 md:col-start-5 lg:col-start-4 flex flex-col gap-8 text-lg text-gray-700 leading-relaxed">
      {children}
    </div>
  );
}

const getTitleClass = (text) => {
  const length = text.length;

  // Very Long Title (e.g. > 60 chars) -> Smaller
  if (length > 60) {
    return "text-3xl";
  }
  // Medium Title (e.g. 30-60 chars) -> Medium
  if (length > 30) {
    return "text-5xl";
  }
  // Short Title -> Huge
  return "text-6xl";
};

export function MainTitle({ title, subTitle, children }) {
  const dynamicSizeClass = getTitleClass(title);
  return (
    <div className="md:col-span-4 lg:col-span-3">
      <div className="sticky top-32 text-left">
        <h1
          className={`relative font-display font-medium text-4xl sm:text-6xl  leading-none inline-block text-brand-dark ${dynamicSizeClass}`}
        >
          {title}
          <span className="absolute bottom-1 -z-10 block h-3 w-full bg-brand-lime"></span>
        </h1>

        {subTitle && (
          <h2 className="mt-8 text-xl text-gray-500 font-sans font-medium">
            {subTitle}
          </h2>
        )}

        {/* Any extra buttons/elements passed to title area */}
        <div className="mt-8 flex flex-col items-start">{children}</div>
      </div>
    </div>
  );
}
